import { connect } from 'react-redux'

import { RecurringPopUpModal } from '@components/popUps'

import coordinators from '@coordinators'
import services from '@services'
import presenters from '@presenters'
import { HandleError } from '@coordinators/composed'
import { config } from 'hungry-core2'

const mapStateToProps = (state) => {
  const { user = {}, headquarter = {}, router } = state
  const { lastLoggedInHq } = user
  const { userHeadquarters = [] } = headquarter
  const userHeadquarter =
    userHeadquarters.find((hq) => hq.id === lastLoggedInHq) || {}
  const port = router.location.port === 3000 ? 3001 : 3000
  const uri =
    config.marketplace_url +
    (config.marketplace_url === 'http://localhost' ? `:${port}` : '')
  const invoiceUrl = `${uri}/pop-up-invoices`
  const popUpUrl = `${config.api_host}/pop-ups`

  return {
    invoiceUrl,
    popUpUrl,
    locale: userHeadquarter.locale,
    headquarter: userHeadquarter.id,
  }
}

const mapDispatchToProps = () => {
  const {
    pResponseAccountExecutives,
    pResponseChefs,
    pResponsePopUpAddOnMenuItems,
    pResponsePopUpOnSiteMenuItems,
    pResponsePopUpServiceItems,
    pResponsePopUpConcepts,
    pResponsePopUpAccount,
    pResponsePopUpAccounts,
  } = presenters.Api
  const { PopUpService, RecurringPopUpService, RestService, UIService } =
    services
  const {
    GetPopUpPrePaymentTax,
    LoadAccount,
    LoadAccountExecutives,
    LoadPopUpMenuItems,
    LoadPopUpServiceItems,
    SearchPopUpAddOnChefs,
    SaveRecurringPopUp,
    SearchDetailAccounts,
    SearchPopUpConcepts,
  } = coordinators
  const { newMenu } = PopUpService
  const { newRecurringPopUp, newTimeSlot } = RecurringPopUpService

  const getPopUpClient = LoadAccount({
    RestService,
    pResponseAccount: pResponsePopUpAccount,
  })
  const getPopUpPrePaymentTax = GetPopUpPrePaymentTax({
    RestService,
    HandleError,
  })
  const saveRecurringPopUp = SaveRecurringPopUp({
    RestService,
    UIService,
    HandleError,
  })
  const searchPopUpConcepts = SearchPopUpConcepts({
    RestService,
    pResponsePopUpConcepts,
    HandleError,
  })
  const loadPopUpMenuItems = LoadPopUpMenuItems({
    RestService,
    pResponseMenuItems: pResponsePopUpAddOnMenuItems,
  })
  const loadPopUpOnSiteItems = LoadPopUpMenuItems({
    RestService,
    pResponseMenuItems: pResponsePopUpOnSiteMenuItems,
  })
  const loadPopUpServiceItems = LoadPopUpServiceItems({
    RestService,
    pResponsePopUpServiceItems,
  })
  const searchPopUpClients = SearchDetailAccounts({
    RestService,
    pResponseAccounts: pResponsePopUpAccounts,
  })
  const searchSalesReps = LoadAccountExecutives({
    RestService,
    pResponseAccountExecutives,
  })(false) // is not vcx
  const searchPopUpAddOnChefs = SearchPopUpAddOnChefs({
    RestService,
    pResponseChefs,
  })
  const showConfirmationModal = UIService.ConfirmationModal.show
  const { displayWarningMessage, displaySuccessMessage } =
    UIService.FlashMessage

  return {
    displayWarningMessage,
    displaySuccessMessage,
    getPopUpPrePaymentTax,
    getPopUpClient,
    loadPopUpMenuItems,
    loadPopUpOnSiteItems,
    loadPopUpServiceItems,
    newRecurringPopUp,
    newTimeSlot,
    newMenu,
    saveRecurringPopUp,
    searchPopUpAddOnChefs,
    searchPopUpClients,
    searchPopUpConcepts,
    searchSalesReps,
    showConfirmationModal,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RecurringPopUpModal)
